<template>
  <div class="posgrados">
    <v-container fluid style="position:relative">
      <v-container class="header-container">
        <h2 class="notranslate ">
          {{ $t("news.title") }}
        </h2>
      </v-container>
      <!-- v-if="!isTablet"  -->
      <v-row justify="center" style="position:relative" no-gutters>
        <v-col cols="12" md="2" lg="2" xl="2" class="aside-container">
          <div class="aside notranslate">
            <div class="wrapper-shit">
              <h6 class="notranslate">{{ $t("news.filtersTitle") }}</h6>
              <div class="options  ">
                <v-select
                  v-model="yearSelected"
                  background-color="white lighten"
                  placeholder="Todas"
                  item-text="name"
                  item-value="name"
                  label="Año"
                  hide-details
                  :items="years"
                  class="mt-8"
                />

                <v-select
                  v-model="monthSelected"
                  background-color="white lighten"
                  placeholder="Todas"
                  item-text="name"
                  item-value="value"
                  label="Mes"
                  hide-details
                  :items="months"
                  class="mt-8"
                />
              </div>

              <v-card v-if="!isTablet" style="width: 286px" @click="openPodcast()" class="mt-10 pa-0 podcast">
                <v-img height="220" :src="podcast" class="podcast-image"> </v-img>
                <v-card-text>
                  <h6 class=" mt-1">Radar Oceanografico</h6>
                  <p>Escucha el podcast de la UABC Radio</p>
                </v-card-text>
              </v-card>

              <div v-if="!isTablet" class="calendar ">
                <!-- <v-img :src="altLogo" width="180px" class="logo-uabc" /> -->
                <!-- <h4 class="notranslate mt-10">{{ $t("posgrados.calendario") }}</h4> -->
                <p class="links mt-6 mb-2 center-text">
                  <b
                    >Síguenos en nuestras <br />
                    redes sociales</b
                  >
                </p>
                <div class="d-flex mt-0">
                  <v-btn icon color="black" @click="goToLink(facebook)">
                    <v-icon size="35" v-text="'mdi-facebook'" />
                  </v-btn>
                  <v-btn icon class="ml-3 black--text" @click="goToLink(instagram)">
                    <v-icon size="35" v-text="'mdi-instagram'" />
                  </v-btn>
                </div>
              </div>
            </div>
          </div>
        </v-col>

        <v-col
          cols="12"
          md="7"
          lg="7"
          xl="6"
          class="content-wrapper"
          v-if="getNewsFromDate(parseInt(monthSelected) + 1, yearSelected).length > 0"
        >
          <div class="d-flex justify-space-between">
            <p class="grey-2">{{ months[monthSelected].name + " " + yearSelected }}</p>
            <p class="grey-2">
              {{ getNewsFromDate(parseInt(monthSelected) + 1, yearSelected).length }} Resultados
            </p>
          </div>

          <el-card
            v-if="monthSelected != null"
            class="noticia-card"
            v-for="(noticia, i) in getNewsFromDate(parseInt(monthSelected) + 1, yearSelected)"
            data-aos="fade-up"
            :data-aos-delay="50 * i"
          >
            <NoticiaCell :noticia="noticia" :index="i" :newsPath="newsPath" />
          </el-card>
        </v-col>

        <v-col cols="12" md="7" lg="7" xl="6" class="not-found-wrapper" v-else>
          <lottie-animation
            class="ma-0 boat"
            height="60%"
            path="../search-not-found.json"
            :loop="true"
            :autoPlay="true"
            :speed="0.3"
          />
          <h2 class="center-text">No hay resultados</h2>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import { NoticiaCell } from "../components/Lists";
import LottieAnimation from "lottie-vuejs/src/LottieAnimation.vue"; // import lottie-vuejs

export default {
  name: "posgrados",
  components: { LottieAnimation, NoticiaCell },
  data: () => ({
    isTablet: window.innerWidth < 960,
    yearSelected: "",
    years: [{ name: "2001" }],
    monthSelected: null,
    months: [
      { name: "Enero", value: "0" },
      { name: "Febrero", value: "1" },
      { name: "Marzo", value: "2" },
      { name: "Abril", value: "3" },
      { name: "Mayo", value: "4" },
      { name: "Junio", value: "5" },
      { name: "Julio", value: "6" },
      { name: "Agosto", value: "7" },
      { name: "Septiembre", value: "8" },
      { name: "Octubre", value: "9" },
      { name: "Noviembre", value: "10" },
      { name: "Diciembre", value: "11" }
    ],
    monthEneable: null
  }),
  computed: {
    facebook: function() {
      return this.$info.about.information.facebook;
    },
    instagram: function() {
      return this.$info.about.information.instagram;
    },
    altLogo: () => require("../assets/logo_uabc_alt.png"),
    podcast: () => require("../assets/images/uabc_radio_radar_1.jpeg"),
    getNewsYears() {
      const { noticias } = this.$info.home;
      const year_list = [
        ...new Set(
          noticias.map(news => {
            return new Date(news.date).getFullYear();
          })
        )
      ];

      this.years = year_list.map(year => {
        const formatedYear = { name: year };
        formatedYear.months = [
          { name: "Enero", value: "0" },
          { name: "Febrero", value: "1" },
          { name: "Marzo", value: "2" },
          { name: "Abril", value: "3" },
          { name: "Mayo", value: "4" },
          { name: "Junio", value: "5" },
          { name: "Julio", value: "6" },
          { name: "Agosto", value: "7" },
          { name: "Septiembre", value: "8" },
          { name: "Octubre", value: "9" },
          { name: "Noviembre", value: "10" },
          { name: "Diciembre", value: "11" }
        ];
        var activeNew = null;
        formatedYear.months.forEach((month, i) => {
          const isEneable = this.getNewsFromDate(parseInt(month.value) + 1, year).length > 0;
          month.disabled = !isEneable;
          if (isEneable) activeNew = month.value;
        });
        formatedYear.activeNew = activeNew;

        return formatedYear;
      });
      console.warn(this.years);
      this.years.reverse();
    },
    currentMonth() {
      return this.months[new Date().getMonth()];
    }
  },
  methods: {
    onresize: function() {
      this.isTablet = window.innerWidth < 960;
    },

    setNoticia(noticia) {
      this.noticia = noticia;
      this.showNoticia = true;
    },
    imageShouldShow(height) {
      return this.$vuetify.breakpoint[height];
    },
    getNewsFromDate(month, year) {
      const { noticias } = this.$info.home;
      var news_from_date = [];
      noticias.forEach((noticia, i) => {
        const date = new Date(noticia.date);
        if (`${date.getFullYear()}/${date.getMonth() + 1}` == `${year}/${month}`) {
          news_from_date.push({ ...noticia, id: i });
        }
      });
      news_from_date = news_from_date.sort((a, b) => {
        const aDate = new Date(a.date);
        const bDate = new Date(b.date);
        if (aDate < bDate) return 1;
        if (aDate > bDate) return -1;
        return 0;
      });

      return news_from_date;
    }
  },
  beforeMount() {
    this.getNewsYears;
    this.yearSelected = this.years[0].name;
    console.warn(this.years[0].activeNew);
    this.monthSelected = this.years[0].activeNew;
  },
  created: function() {
    window.addEventListener("resize", this.onresize);
  },
  destroyed: function() {
    window.removeEventListener("resize", this.onresize);
    this.$loading().close();
  },
  mounted() {}
  // watch: {
  //   "$route.params.especiality": {
  //     handler: function(search) {
  //       this.loadData;
  //     },
  //     deep: true,
  //     immediate: true
  //   }
  // }
};
</script>
<style lang="scss" scoped>
@import "@/assets/styles/global";
.noticia-card {
  padding: 0 !important;
  margin: 0 !important;
  width: 100%;
  height: 166px;
  margin-bottom: 20px !important;
}
.header-container {
  position: relative;
  min-height: 100px;
}
h6 {
  border-left: $green solid 4px;
  padding-left: 5px;
  font-size: 20px;
  text-overflow: ellipsis;
  overflow: hidden;
  // Addition lines for 2 line or multiline ellipsis
  display: -webkit-box !important;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  white-space: normal;
}
h4 {
  text-align: left !important;
}
h5 {
  margin: 30px 0 15px 0;
}
.read-more {
  width: 171px;
  height: 39px;

  * {
    color: white !important;
  }
}
.podcast {
  border-radius: 10px;
}
.content-wrapper {
  display: flex;
  flex-direction: column;
  padding-left: 2vw !important;
  padding-right: 2vw !important;
  min-height: 80vh;
  // px-10 d-flex flex-column
}
.posgrados {
  display: flex;
  position: relative;
  padding-top: 100px;
  // padding-top: 200px;
}
.aside-container {
  max-width: 300px;
  width: 300px !important;
  position: relative;
}
.aside {
  // margin-top: 50px;
  position: -webkit-sticky;
  position: sticky;
  top: 50px; /* required */
  display: flex;
  align-items: center;
  flex-direction: column;
  text-align: left;
  width: 300px !important;
  .wrapper-shit {
    position: relative;
    margin-top: 60px;
  }
  // height: 100%;
  //background-color: red;
  .calendar {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 286px;
    height: 142px;
    border-radius: 10px;
    margin-top: 25px;
    i {
      color: #f4c268;
    }

    .logo-uabc {
      position: absolute;
      top: -50px;
    }
  }
}
.options {
  display: flex;
  flex-direction: column;
  position: relative;
}
@media (max-width: 960px) {
  .posgrados {
    padding-top: 75px;
    margin-bottom: 10px !important;
  }
  .content-wrapper {
    margin-top: 40px;
  }
  .aside-container {
    max-width: 100%;
    width: 100% !important;
    position: relative;
    padding: 0 2vw !important;
    .aside {
      width: 100% !important;
    }
    .wrapper-shit {
      margin-top: 0;
      width: 100%;
      .options {
        * {
          margin-right: 2vw !important;
        }
      }
    }
  }
  .options {
    flex: 1;
    flex-direction: row;
  }
}
</style>

<style scoped lang="scss">
@import "@/assets/styles/global";
.animation-wrapper {
  display: flex;
}
.not-found-wrapper {
  min-height: 30vh;
  display: flex;
  // top: -40px !important;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.boat {
  width: 60% !important;
}
h2 {
  margin-top: -10px;
  text-decoration: underline;
  color: $dark-blue !important;
}
@media (max-width: 960px) {
  .not-found-wrapper {
    min-height: 85vh;
  }
  // .boat {
  //   width: 70% !important;
  // }
  h2 {
    margin-top: -20px;
  }
}
@media (max-width: 768px) {
  .boat {
    width: 100% !important;
  }
}
</style>
